import { Platform, TouchableOpacity, View } from 'react-native';
import React, { useMemo } from 'react';
import CreditCardSVG from '~/assets/img/credit-card.svg';
import BarcodeScanSVG from '~/assets/img/barcode-scan.svg';
import AccountDebitSVG from '~/assets/img/account-debit.svg';
import { Text } from '~/components';
import colors from '~/assets/themes/colors';

interface Props {
  data: Checkout.PaymentMethod;
  value: string | undefined;
  onPress: (code: string) => void;
}

const PaymentMethod = ({ data, value, onPress }: Props) => {
  const isSelected = useMemo(() => value === data.code, [value, data]);

  const paymentConfig = useMemo(() => {
    const config = {
      'credit-card': {
        icon: (
          <CreditCardSVG
            stroke={isSelected ? colors.primary[600] : colors.gray[600]}
          />
        ),
      },
      'bank-slip': {
        icon: (
          <BarcodeScanSVG
            color={isSelected ? colors.primary[600] : colors.gray[600]}
          />
        ),
      },
      'account-debit': {
        icon: (
          <AccountDebitSVG
            color={isSelected ? colors.primary[600] : colors.gray[600]}
          />
        ),
      },
    };

    return { ...config[data.method], title: data.description };
  }, [data, isSelected]);

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      className={`px-4 py-6 mb-4 rounded-md flex-row items-center justify-between shadow-md ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      } bg-white border  ${isSelected ? 'border-primary-600' : 'border-white'}`}
      onPress={() => onPress(data.code as string)}
    >
      <View className="flex-row items-center">
        {paymentConfig.icon}
        <Text
          className={`${
            isSelected ? 'text-primary-600' : 'text-gray-600'
          } pl-2 `}
        >
          {paymentConfig.title}
        </Text>
      </View>

      <View
        className={`w-5 h-5 border border-gray-400 rounded-xl items-center justify-center ${
          isSelected ? 'bg-primary-20 border-primary-20' : 'bg-white'
        }`}
      >
        {isSelected && (
          <View className="w-[10px] h-[10px] bg-primary-600 rounded-md" />
        )}
      </View>
    </TouchableOpacity>
  );
};

export default PaymentMethod;
